import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'

import '@fontsource/ibm-plex-sans-thai/400.css'
import '@fontsource/ibm-plex-sans-thai/500.css'
import '@fontsource/ibm-plex-sans-thai/600.css'
import '@fontsource/ibm-plex-sans-thai/700.css'

import '@fontsource/ibm-plex-sans-thai-looped/400'
import '@fontsource/ibm-plex-sans-thai-looped/500'
import '@fontsource/ibm-plex-sans-thai-looped/600'
import '@fontsource/ibm-plex-sans-thai-looped/700'

import '@fontsource/inter/400'
import '@fontsource/inter/500'
import '@fontsource/inter/600'
import '@fontsource/inter/700'

import '@fontsource/geist-sans/400'
import '@fontsource/geist-sans/500'
import '@fontsource/geist-sans/600'
import '@fontsource/geist-sans/700'

import '@fontsource/geist-mono/400'

import '@fontsource/caveat/400'
import '@fontsource/caveat/700'

import '@fontsource/bai-jamjuree/400.css'
import '@fontsource/bai-jamjuree/500.css'

import App from './App'


ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <StrictMode>
    <App />
  </StrictMode>
)
